import React from 'react';
import { useNavigate } from 'react-router-dom';
import { formatDate } from '../utils/formatDate';
import './ArticleCard.css';

function ArticleCard({ id, title, description, date }) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/article/${id}`);
  };

  return (
    <article className="article-card" onClick={handleClick}>
      <div className="article-card-content">
        <h2 className="article-card-title">{title.toLowerCase()}</h2>
        <p className="article-card-date">{formatDate(date)}</p>
        <p className="article-card-description">{description.toLowerCase()}</p>
      </div>
    </article>
  );
}

export default ArticleCard;
